import controller from '../../Controller.js';
function UpdateCountSavedCourses(container) {

    const savedCoursesKey = container.dataset.courseStorageId ?? "courses";

    function init() {
        updateCoursesCountDisplay();

        function countSavedCourseIds() {
            const courses = localStorage.getItem(savedCoursesKey);
            return courses ? JSON.parse(courses).length : 0;
        }

        function updateCoursesCountDisplay() {
            const count = countSavedCourseIds();
            if (container) {
                container.textContent = count;
            }
        }

    }

    return {
        init: init
    }

}

controller.add('UpdateCountSavedCourses', UpdateCountSavedCourses);
export default UpdateCountSavedCourses;
